import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AutocompleteDropdownConfig } from './filter-config';
import { I18n } from 'common/i18n';
import { changeRequester } from 'common/components/AssetBrowser/actions/filters';
import { FilterType } from './types';
import { FilterScope, getScope } from './translations';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';
import { getFilteredOptions } from './filter-helper';

const scope = getScope(FilterScope.Requester);

/**
 * Type inferred from returned data.
 */
type ApprovalRequester = {
  value: string | null;
  title: string | null;
};

const getRequesterOptions = (
  input: string,
  list: ApprovalRequester[] = [],
): IBaseListDropdownOption<string | null>[] => {
  const allOptions = list.map((item) => ({
    label: item.title || '',
    value: item.value,
  }));

  return getFilteredOptions(allOptions, input);
};

export const requesterConfigs: AutocompleteDropdownConfig<ApprovalRequester> = {
  filterName: Filters.Requester,
  label: I18n.t('label', { scope }),
  placeholder: I18n.t('placeholder', { scope }),
  filterCallback: getRequesterOptions,
  dispatchAction: changeRequester,
  filterType: FilterType.AutocompleteDropdown,
  filterListName: FilterList.ApprovalRequesters,
};
